var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60156 2.91797H16.1016C16.5158 2.91797 16.8516 3.25376 16.8516 3.66797V15.668C16.8516 16.0822 16.5158 16.418 16.1016 16.418H2.60156C2.18735 16.418 1.85156 16.0822 1.85156 15.668V3.66797C1.85156 3.25376 2.18735 2.91797 2.60156 2.91797ZM15.3516 6.09641L9.40541 11.4215L3.35156 6.07992V14.918H15.3516V6.09641ZM3.73516 4.41797L9.39799 9.41447L14.9773 4.41797H3.73516Z",
    fill: "#878EA6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEMail);
export default __webpack_public_path__ + "static/media/E-mail.80685b4932d6201f16e222e01229ce28.svg";
export { ForwardRef as ReactComponent };